import { useMsal } from '@azure/msal-react';
import { useCallback, useState } from 'react';
import { formatPiiWarning } from './format-pii-warning';
import { useStores } from './use-stores';

export const useRubricPiiScan = () => {
  const { instance } = useMsal();
  const { apiStore } = useStores();
  const [piiWarning, setPiiWarning] = useState<string | null>(null);
  const [isScanning, setIsScanning] = useState(false);

  const clear = useCallback(() => setPiiWarning(null), []);

  const scan = useCallback(async (text: string) => {
    if (!text || text.trim().length === 0) {
      setPiiWarning(null);
      return;
    }

    setIsScanning(true);
    try {
      const response = await apiStore.scanRubricPii(instance, text);
      setPiiWarning(formatPiiWarning(response.categories));
    } finally {
      setIsScanning(false);
    }
  }, [apiStore, instance]);

  return { scan, piiWarning, isScanning, clear };
};
